<template>
  <section class="tss-footer">
    <div v-if="isSupimaLanding || isActiveWearLanding || isWinterWearLanding" class='supima-footer d-flex justify-content-center'>
    <img :src="$parent.isDesktop ? imgBaseUrl + 'supima-footer-web.jpg' : imgBaseUrl + 'supima-footer-mobile.jpg'"/>
  </div>
  <div v-else class="additional-footer-container">
    <div class="additional-heading" v-if="footerBrandText">
     {{ footerBrandText }}
    </div>
    <div class="additional-footer-content">
      <div class="additional-item">
        <h3 class="additional-stats">Over <span class="fbold">6 Million</span> Happy Customers</h3>
      </div>
    </div>
  </div>
  <div v-if="!isCodCheckoutLogin" id="accordionside" role="tablist" aria-multiselectable="true" :style="`${this.footerCollapseStyle}`">
    <div>
      <div class="cusTabs accordiontabs">
        <div class="card-header d-flex justify-content-center flex-column"
        role="tab" id="headingFooter"
        v-if="!$parent.isDesktop"
        >
          <h5 class="mb-0 accordianheadings">
            <a data-toggle="collapse" ref="applyFooter" data-parent="#accordionside" href="#collapseFooter" :aria-expanded="`${this.footerCollapseControl.expanded}`"
            aria-controls="collapseFooter">
              <span>Know more about The Souled Store</span>
            </a>
          </h5>
        </div>
      </div>
      <div id="collapseFooter" :class="$parent.isDesktop ? 'show' : this.footerCollapseControl.expandedClass" class="collapse" role="tabpanel" aria-labelledby="headingFooter">
        <div class="w-100 px-2 py-4" style="background: #ddd" v-if="!$parent.isDesktop && !isBflUtm && isSelectedCountryIndia">
          <div class="text-uppercase text-center">
            <div class="app-download-header" style="color: black">
              <b><i class="fa fa-mobile mr-1" aria-hidden="true"></i> experience the souled store app</b>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <a @click="triggerEvent('Play Store')" href="https://play.google.com/store/apps/details?id=com.thesouledstore">
              <img class="app-store-logo mr-2" data-src="https://tss-static-images.gumlet.io/icons/play-store.png" alt="Download app on google play store" />
            </a>
            <a @click="triggerEvent('App Store')" href="https://apps.apple.com/in/app/thesouledstore/id1493897434">
              <img class="app-store-logo ml-2" data-src="https://tss-static-images.gumlet.io/icons/app-store.png" alt="Download app on apple app store" />
            </a>
          </div>
        </div>
        <footer v-if="!hideFooter" class="" :class="overlayBottomPaddingVisible ? 'overlayBottomPadding' : ''">
          <div class="container">
            <div class="row">
              <div class="col-6 col-md-3 col-xs-6" v-if="shopNow">
                <div class="footerlinks">
                  <h5 class="fred">SHOP FOR</h5>
                  <div v-html="formattedshopNow"></div>
                </div>
              </div>
              <div class="col-6 col-md-3 col-xs-6">
                <div class="footerlinks">
                <h5 class="fred">NEED HELP</h5>
                  <ul>
                    <li>
                      <router-link to="/contact-us"><span @click="appFooterEventHandler('Contact Us')">Contact Us</span></router-link>
                    </li>
                    <li>
                      <router-link to="/orders"><span @click="appFooterEventHandler('Track Order')">Track Order</span></router-link>
                    </li>
                    <li v-if="isSelectedCountryIndia">
                      <router-link to="/faqs"><span @click="appFooterEventHandler('Returns & Refunds')">Returns &amp; Refunds</span></router-link>
                    </li>
                    <li>
                      <router-link to="/faqs"><span @click="appFooterEventHandler('FAQs')">FAQs</span></router-link>
                    </li>
                    <li>
                      <router-link to="/profile"><span @click="appFooterEventHandler('My Account')">My Account</span></router-link>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-6 col-md-3 col-xs-6">
                <div class="footerlinks">
                  <h5 class="fred">COMPANY</h5>
                  <ul>
                    <li>
                      <router-link to="/about-us"><span @click="appFooterEventHandler('About Us')">About Us</span></router-link>
                    </li>
                    <li>
                      <router-link to="/investor-relation"><span @click="appFooterEventHandler('Investor Relation')">Investor Relation</span></router-link>
                    </li>
                    <li>
                      <router-link to="/careers"><span @click="appFooterEventHandler('Careers')">Careers</span></router-link>
                    </li>
                    <li v-if="!showNewStoreNearMe">
                      <router-link to="/stores-near-me"><span @click="appFooterEventHandler('Stores Near Me')">Stores Near Me</span></router-link>
                    </li>
                    <li v-if="bannerPlaceHolderForGiftVoucher && isSelectedCountryIndia">
                      <router-link to="/gift-voucher"><span @click="appFooterEventHandler('Gift Vouchers')">Gift Vouchers</span></router-link>
                    </li>
                    <li>
                      <router-link to="/from-the-soul"><span @click="appFooterEventHandler('From The Soul')">Community Initiatives</span></router-link>
                    </li>
                    <!-- <li>
                      <router-link to="/souled-army"><span @click="appFooterEventHandler('Souled Army')">Souled Army</span></router-link>
                    </li> -->
                  </ul>
                </div>
              </div>
              <div class="col-6 col-md-3 col-xs-6">
                <div class="footerlinks">
                  <h5 class="fred">MORE INFO</h5>
                  <ul>
                    <li>
                      <router-link to="/terms-and-conditions"><span @click="appFooterEventHandler('T&C')">T&C</span></router-link>
                    </li>
                    <li>
                      <router-link to="/privacy-policy"><span @click="appFooterEventHandler('Privacy Policy')">Privacy Policy</span></router-link>
                    </li>
                    <li>
                      <router-link to="/sitemap"><span  @click="appFooterEventHandler('Sitemap')">Sitemap</span></router-link>
                    </li>
                    <li v-if="bannerPlaceHolderForGetNotified">
                    <router-link to="/getnotified"><span> Get Notified</span> </router-link>
                  </li>
                    <li v-if="bannerPlaceHolderForBlog && bannerPlaceHolderForBlog.description">
                      <a :href="bannerPlaceHolderForBlog && bannerPlaceHolderForBlog.description" target="_blank" rel="noopener noreferrer"><span  @click="appFooterEventHandler('Blog')">{{bannerPlaceHolderForBlog.tag_text || 'Blog'}}</span></a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-6 col-md-3 col-xs-6" v-if="showNewStoreNearMe && isSelectedCountryIndia">
                <div class="footerlinks">
                  <h5 class="fred">STORE NEAR ME</h5>
                    <ul>
                      <li v-for="store in storeListDetails" :key="store.id" @click="appFooterEventHandler(store.city)">
                        <router-link :to="{ path: '/stores-near-me', hash: `${store.city}-${store.id}`}" v-if=" $parent.isDesktop">
                          <a :href="`#${store.city}`" >
                            <span> {{ store.city }} </span>
                          </a>
                        </router-link>
                        <router-link :to="{ path: '/stores-near-me', query: { q: store.city } }" v-else>
                          <a>
                            <span> {{ store.city }} </span>
                          </a>
                        </router-link>
                      </li>
                    </ul>
                    <button class="stores-btn" v-if="storeDetails.length>4" @click="toggleView">
                       {{ isExpanded ? 'View Less' : 'View More' }}
                    </button>
                </div>
              </div>
              <div class="col-12" v-if="shopNow && $parent.isDesktop">
                <div v-if="isSelectedCountryIndia" class="footerlinks notAnimate cod">
                  <ul class="">
                    <li>
                      <span><i class=" circleicon_light fa fa-rupee"></i> COD Available</span>
                    </li>
                    <li class="showdesktop">
                      <span><i class="circleicon_light fa fa-refresh"></i> 30 Days Easy Returns</span>
                    </li>
                    <li>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-6 col-md-3 col-xs-6" v-if="!$parent.isDesktop && shopNow">
                <div v-if="isSelectedCountryIndia" class="footerlinks notAnimate">
                  <ul class="">
                    <li>
                      <span><i class=" circleicon_light fa fa-rupee"></i> COD Available</span>
                    </li>
                    <li class="showdesktop">
                      <span><i class="circleicon_light fa fa-refresh"></i> 30 Days Easy Returns</span>
                    </li>
                    <li>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-6 col-md-3 col-xs-6" v-if="!shopNow">
                <div v-if="isSelectedCountryIndia" class="footerlinks notAnimate">
                  <ul class="">
                    <li>
                      <span><i class=" circleicon_light fa fa-rupee"></i> COD Available</span>
                    </li>
                    <li>
                      <span><i class="circleicon_light fa fa-refresh"></i> 30 Days Easy Returns</span>
                    </li>
                    <li>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row justify-content-center align-content-center my-3" v-if="$parent.isDesktop && !isBflUtm && isSelectedCountryIndia">
              <div>
                <div class="text-uppercase">
                  <div class="app-download-header">
                  <b><i class="fa fa-mobile mr-1" aria-hidden="true"></i> experience the souled store app</b>
                  </div>
                </div>
                <div class="d-flex">
                  <a @click="triggerEvent('Play Store')" class="mr-3" href="https://play.google.com/store/apps/details?id=com.thesouledstore">
                    <img class="app-store-logo" data-src="https://tss-static-images.gumlet.io/icons/play-store.png" alt="Download app on google play store" />
                  </a>
                  <a @click="triggerEvent('App Store')" href="https://apps.apple.com/in/app/thesouledstore/id1493897434">
                    <img class="app-store-logo" data-src="https://tss-static-images.gumlet.io/icons/app-store.png" alt="Download app on apple app store" />
                  </a>
                </div>
              </div>
            </div>
            <div class="footersocial">
              <div style="display:inline">Follow Us: &nbsp; </div>
              <div class="inlineEl pt20">
                <follows-withsocial sizeicon="small" :showtitle="false" :callerComp="'footer'" ></follows-withsocial>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
          <hr class="divider d10 showinmobile"/>
          <div class="container">
            <div class="borderbox">
              <div id="footAccord" role="tablist" aria-multiselectable="true" class="footeraccordian">
                <div class="card">
                  <div class="card-header" role="tab" id="headingOne">
                    <h5 class="mb-0 accordianheading fred mt-0">
                      <a data-toggle="collapse" data-parent="#footAccord" href="#footAccordOne" aria-expanded="false"
                      aria-controls="footAccordOne" class="custom-font-size">
                      NAVIGATION LINKS
                      </a>
                    </h5>
                  </div>
                  <div id="footAccordOne" class="collapse pb-3 px-3" role="tabpanel" aria-labelledby="headingOne">
                    <div class="navi" v-for="(item,index) in populerSearchData" :key="index">
                      <div class="brand-cover text-uppercase d-block">{{item.name}}</div>
                      <div v-for="(cat, catIndex) in item.categories" :key="catIndex">
                        <router-link v-if="cat.url_key" :to="cat.url_key"><span @click="appFooterEventHandler(cat.name, `${item.name} > ${cat.name}`)">{{cat.name}}</span></router-link>
                        <div v-for="(sub, subCatIndex) in (cat && cat.sub_categories)" :key="subCatIndex">
                          <router-link v-if="sub.url_key" :to="sub.url_key"><span @click="appFooterEventHandler(sub.name, `${item.name} > ${cat.name} > ${sub.name}`)">{{sub.name}}</span></router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="card"
                  v-if="!($route.path == '/checkout' || $route.path == '/delivery-address' || $route.path == '/cart' || (($route.path).startsWith('/product')))"
                >
                  <div class="card-header" role="tab" id="headingTwo">
                    <h5 class="mb-0 accordianheading fred mt-0 text-uppercase">
                      <a
                        class="collapsed" data-toggle="collapse" data-parent="#footAccord"
                        href="#footAccordTwo" aria-expanded="false" aria-controls="footAccordTwo"
                      >
                        <h2 v-if="footerTextTitle" class="custom-font-size"> About <span v-html="formattedArtist"></span></h2>
                        <h2 v-else-if="$route.params.artname" class="custom-font-size">Artist Information</h2>
                        <h2 v-else-if="$route.name === 'membership'" class="custom-font-size">The Souled Store Membership</h2>
                        <h2 v-else class="custom-font-size">Who we are</h2>
                      </a>
                    </h5>
                  </div>
                  <div id="footAccordTwo" class="collapse" role="tabpanel" aria-labelledby="headingTwo">
                    <div class="card-block col-md-8">
                      <div id='about-product' class="navigationbox d-block text-justify">
                        <div v-if="$route.name === 'membership'">
                        We, at The Souled Store, aim to give you something you'll love, something you can use to express yourself, and, simply put, something to put a smile on your face. We know you love our collection of awesome t-shirts, notebooks, boxer shorts, mobile covers, socks, mugs, pins, flip-flops, badges, stickers, backpacks, and everything else. So we decided to reward your loyalty with a little token of our appreciation- The Souled Store Membership. <br/><br/>
                        Our yearly membership offers you all your favourite products at massive discounts, free shipping, prioritised delivery, and early access. The perks are so good, we aren't sure why we didn't launch this earlier!<br/><br/>
                        </div>
                        <div v-else-if="footerText" v-html="formattedFooterText"></div>
                        <div v-else v-html="defaultFooterText"></div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <p class="text-uppercase" style="text-decoration: underline;" v-html="formattedArtist && formattedArtist.length ? `${formattedArtist} PRICE LIST` : ''"></p>
                      <table class="table" width="100%" v-if="allProducts">
                        <tbody>
                          <tr class="font-weight-bold">
                            <td><span v-html="formattedArtist"></span></td>
                            <td>Price</td>
                          </tr>
                          <tr v-for="(prm, index) in allProducts" :key="prm.id || Math.random()">
                            <template v-if="index<10 && !prm.tiptiles">
                              <td>
                                <router-link :to="'product/'+prm.product_slug">{{prm.product}}</router-link>
                              </td>
                              <td>{{prm.price && getround(prm.price)}}</td>
                            </template>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="card" v-if="(($route.path).startsWith('/product')) && formattedFooterTextArtist">
                  <div class="card-header" role="tab" id="headingThree">
                    <h5 class="mb-0 accordianheading fred mt-0">
                      <a
                        class="collapsed" data-toggle="collapse" data-parent="#footAccord"
                        href="#footAccordThree" aria-expanded="false" aria-controls="footAccordThree"
                      >
                        <span>ARITIST'S DETAILS</span>
                      </a>
                    </h5>
                  </div>
                  <div id="footAccordThree" class="collapse" role="tabpanel" aria-labelledby="headingThree">
                    <div class="card-block">
                      <div class="navigationbox" style="display: block;">
                        <div v-html="formattedFooterTextArtist" class="text-justify"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
          <hr class="divider d10 showmobile"/>
          <div v-if="isSelectedCountryIndia" class="container mob_mtb0 footerIcon">
            <div class="row mbrow">
              <div class="col-md-6 col-12 d-md-flex align-items-center">
                <div class="dinline">100% Secure Payment: {{ $route.queries }}</div>
                <div class="parentdinline payment payment-wrapper">
                  <div class="dinline payment-tile phonepay"></div>
                  <div class="dinline payment-tile gpay"></div>
                  <div class="dinline payment-tile amazonpay"></div>
                  <div class="dinline payment-tile mastercard"></div>
                  <div class="dinline payment-tile mobikwik"></div>
                  <div class="dinline payment-tile paytm"></div>
                  <div class="dinline payment-tile credpay"></div>
                  <div class="dinline payment-tile cod"></div>
                </div>
              </div>
              <div class="col-md-6 col-12 shipping-partners d-md-flex align-items-center">
                <div class="iconsdivider">&nbsp;</div>
                <div class="">Shipping Partners:</div>
                <div class="d-flex justify-content-center ship-footer-icon">
                  <div class="dinline payment-tile" v-for="(item, index) in shippingPartners" :key="index">
                    <img :data-src="item.imgPath" :alt="item.imgAlt" class="payopt" width="55" height="29" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="popsearch_section" v-if="this.$route.path != '/' && currentCat != 'winterwear-collection' && currentCat != 'membership'">
            <div class="container">
              <div class="popsearch01" v-if="populerSearchNew.length>0">
                <div class="title012"><h2>POPULAR SEARCHES</h2></div>
                <div class="popsr_cont">
                  <div v-for="(item,i) in populerSearchNew" :key="i">
                    <div v-if="item.url" :class="`populer pop_${i}`">
                      <router-link :to="item.url">
                        <span @click="appFooterEventHandler(item.name, `Popular Searches > ${item.name}`)">{{item.name}}</span>
                      </router-link>
                    </div>
                  </div>
                  <div v-html="formattedpopularSearch" class="populer-extra" v-if="popularSearch"></div>
                </div>
              </div>
            </div>
          </div>
          <!-- <hr class="divider " /> -->
          <p class="text-center mb0">
            <span class="fsemibold">
              <i class="fa fa-copyright"></i>
              <h1 class="footer-h1" v-if="this.$route.path === '/'"> The Souled Store </h1>
              <span v-else>The Souled Store </span>
              {{currentYear}}-{{(currentYear + 1).toString().substr(2,2)}}
            </span>
          </p>
        </footer>
      </div>
      <div class="mbstickyfooter mt20" v-if="(isComboActive && bannerPlaceHolderForMenWomenMsite && !$parent.isDesktop && !bannerPlaceHolderForGoForAppOnlySale) && (this.$route.path === '/men'|| this.$route.path === '/kids' || this.$route.path === '/women' || this.$route.path === '/categories' || this.$route.path === '/mywishlist' || this.$route.path === '/my-account' || this.$route.path === '/membership')">
        <div class="row justify-content-md-center">
          <div class="col-md-12   col">
            <ul class="foot_menu">
              <li @click="footerMenu('/home')">
                <router-link aria-label="Home" :to="webcategory ? '/'+ webcategory:'/'" class="toggle-menu"
                >
                  <img alt="home" :data-src="(this.activeFooterTab != 'categories' && (this.activeFooterTab === 'home' || this.$route.path === '/men' || this.$route.path === '/kids' || this.$route.path === '/women')) ? 'https://prod-img.thesouledstore.com/public/theSoul/images/icons/home.png':'https://stag-img.thesouledstore.com/public/theSoul/images/icons/home_black.png'">
                </router-link>
              </li>
              <li @click="footerMenu('/mywishlist')"><img alt="wishlist" :data-src="this.$route.path === '/mywishlist' && this.activeFooterTab === '' ? 'https://prod-img.thesouledstore.com/public/theSoul/images/icons/wishlist_red.png' : 'https://prod-img.thesouledstore.com/public/theSoul/images/icons/wishlist.png'"></li>
              <li  @click="footerMenu('/categories')"><img alt="categories" :data-src="this.$route.path === '/categories' ? 'https://prod-img.thesouledstore.com/public/theSoul/images/icons/category_red.png' : 'https://prod-img.thesouledstore.com/public/theSoul/images/icons/category.png'"></li>
              <li @click="footerMenu('/membership')"><div><img alt="membership" :data-src="this.$route.path === '/membership' && this.activeFooterTab === '' ? 'https://prod-img.thesouledstore.com/public/theSoul/images/crown-red.png' : 'https://prod-img.thesouledstore.com/public/theSoul/images/crown.png'" class="footer-exclusive-icon"><div class="footer-exclusive-icon-text" :class="{'color-red': this.$route.path === '/membership' && this.activeFooterTab === ''}">{{ setMenuTextExclusive }}</div></div></li>
              <li @click="footerMenu('/my-account')"><img alt="account" :data-src="this.$route.path === '/my-account' && this.activeFooterTab === '' ? 'https://prod-img.thesouledstore.com/public/theSoul/images/icons/profile_red.png' : 'https://prod-img.thesouledstore.com/public/theSoul/images/icons/profile.png'
              "></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  </section>
</template>
<script>
  var $ = require('jquery')
  window.jQuery = $
  import followsWithsocial from './components/widgets/followsWithsocial'
  import subscribeNewsletter from './components/widgets/subscribeNewsletter'
  import {mapGetters} from 'vuex'
  import Vue from 'vue'
  import {appMixins} from './assets/js/appMixins'
  export default {
    name: 'app',
    mixins: [appMixins],
    data () {
      return {
        isExpanded: false,
        populerSearchData: {},
        populerSearchNewData: {},
        imgBaseUrl: process.env.STATIC_IMG_SERVER2,
        defaultFooterText: Vue.ls.get('tss_footerText'),
        tssUrl: '',
        activeFooterTab: '',
        currentYear: new Date().getFullYear(),
        overlayBottomPaddingVisible: false,
        shippingPartners: [
        //   {
        //     imgPath: process.env.STATIC_IMG + 'icons/fedex.png',
        //     imgAlt: 'Fedex'
        //   },
          {
            imgPath: process.env.STATIC_IMG + 'icons/dtdc.png',
            imgAlt: 'DTDC'
          },
          {
            imgPath: process.env.STATIC_IMG + 'icons/delivery.png',
            imgAlt: 'Delhivery'
          },
          {
            imgPath: process.env.IMG_BASE_URL + 'public/theSoul/images/icons/ECOM-Express.png',
            imgAlt: 'Ecom Express'
          },
          {
            imgPath: process.env.IMG_BASE_URL + 'public/theSoul/images/icons/XPRESSBEES.png',
            imgAlt: 'XpressBees'
          }
        ]
      }
    },
    components: {
      followsWithsocial,
      subscribeNewsletter
    },
    methods: {
      toggleView () {
        this.isExpanded = !this.isExpanded
      },
      triggerEvent (eventText) {
        this.appFooterEventHandler(eventText)
      },
      hideOverlay () {
        $('.navbar-collapse').removeClass('activenav')
        $('body').removeClass('_freeze')
        $('.overlay').removeClass('show')
      },
      footerMenu: function (link) {
        $('.overlay').removeClass('show')
        if (link === '/categories') {
          this.activeFooterTab = 'categories'
          this.$store.dispatch('TATVIC_EVENT', {eventName: 'go_to_categories'})
          this.$router.push(link)
        } else {
          if (link === '/home') {
            this.$store.dispatch('TATVIC_EVENT', {eventName: 'go_to_home'})
            this.activeFooterTab = 'home'
            // this.$router.push('/')
          } else if (link === '/my-account') {
            this.activeFooterTab = ''
            this.$store.dispatch('TATVIC_EVENT', {eventName: 'go_to_profile'})
            // this.$store.commit('PROFILE')
            this.$router.push(link)
          } else if (link === '/mywishlist') {
            this.activeFooterTab = ''
            // this.$store.commit('GTAG_EVENT', {eventName: 'CT_Go_to_Wishlist', payload: {pdp_response: (Vue.ls.get('routeObj')).current}})
            // this.$store.commit('GTAG_EVENT', {eventName: 'Go_to_Wishlist', payload: {pdp_response: (Vue.ls.get('routeObj')).current}})
            // this.$store.commit('GTAG_EVENT', {eventName: 'FB_Go_to_Wishlist', payload: {pdp_response: (Vue.ls.get('routeObj')).current}})
            this.$store.commit('GTAG_EVENT', {eventName: `myWishlist_pageview`, payload: {visitFrom: Vue.ls.get('routeObj').current}})
            this.$router.push({ name: 'mywishlist' })
          } else if (link === '/membership') {
            this.activeFooterTab = ''
            this.$store.dispatch('TATVIC_EVENT', {eventName: 'be_exclusive'})
            this.$router.push(link)
          }
        }
      },
      appFooterEventHandler (footerText, navText) {
        if (footerText === 'Play Store' || footerText === 'App Store') {
          this.$store.dispatch('TATVIC_EVENT', {eventName: 'DOWNLOAD_APP',
            payload: {
              STORE_TYPE: footerText
            }
          })
        } else {
          this.$store.dispatch('TATVIC_EVENT', {eventName: 'FOOTER_OPTIONS',
            payload: {
              FOOTER_LINK_TEXT: footerText,
              ...(navText && { NAVIGATION_CATEGORY: navText })
            }
          })
        }
        /** Moengage Event Click on contact us */
        if (footerText === 'Contact Us') {
          this.$store.commit('MOENGAGE_EVENT', {eventName: 'TRACK_CONTACT_US_SIDEMENU_CLICK',
            payload: {
              UserId: this.user && this.user.user_id ? this.user.user_id : 0,
              DateTime: new Date() && new Date().toISOString(),
              Platform: 'WEB',
              PageName: 'Footer'
            }}
          )
        }
      }
    },
    async mounted () {
      $('body').on('click', '.viewContainer, ul.submenu li a, .overlay, .toggle-menu', this.hideOverlay)
      this.populerSearchData = this.navMenuData
      await this.$store.dispatch('GET_STORE_DETAILS_DATA')
      // this.$store.dispatch('SET_HOME_FOOTER_TEXT')
    },
    watch: {
      '$route' (to, from) {
        this.activeFooterTab = ''
      },
      navMenuData () {
        this.populerSearchData = this.navMenuData
      }
    },
    updated () {
      let domCollection = document.querySelectorAll('.filteroption, .mbstickyfooter')
      domCollection && domCollection.length ? this.overlayBottomPaddingVisible = true : this.overlayBottomPaddingVisible = false
    },
    computed: {
      ...mapGetters(
        {
          webcategory: 'webcategory',
          isComboActive: 'isComboActive',
          allProducts: 'allProducts',
          product: 'FETCH_PRODUCT',
          popularSearch: 'popularSearch',
          shopNow: 'shopNow',
          category: 'category',
          footerText: 'footerText',
          footerTextTitle: 'footerTextTitle',
          hideFooter: 'hideFooter',
          navMenuData: 'navMenuData',
          bannerPlcaeHolderData: 'bannerPlcaeHolderData',
          footerCollapseControl: 'footerCollapseControl',
          exclusiveUser: 'exclusiveUser',
          exclusiveDetails: 'exclusiveDetails',
          isExclusive: 'isExclusive',
          storeDetails: 'storeDetails',
          user: 'user',
          isSelectedCountryIndia: 'isSelectedCountryIndia',
          globalBannerPlaceholder: 'globalBannerPlaceholder',
          isCodCheckoutLogin: 'isCodCheckoutLogin'
        }),
      bannerPlaceHolderForMenWomenMsite: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'MENWOMEN_MSITE'.toLowerCase())
      },
      bannerPlaceHolderForGetNotified: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Cart Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_GET_NOTIFIED_WEB'.toLowerCase())
      },
      bannerPlaceHolderForGiftVoucher: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'others' && bannerData.status === true && bannerData.product_type.toLowerCase() === 'ENABLE_GIFT_VOUCHER_WEB'.toLowerCase()
        )
      },
      bannerPlaceHolderForGoForAppOnlySale: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'GO_APP_ONLY_SALE_WEB'.toLowerCase())
      },
      showNewStoreNearMe () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'TOGGLE_STORE_NEAR_ME_SCREENS'.toLowerCase())
      },
      bannerPlaceHolderForBlog () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_BLOG_IN_FOOTER_WEB'.toLowerCase())
      },
      formattedArtist: function () {
        if (!this.footerTextTitle) {
          return
        }
        return this.footerTextTitle.replace('\u0099', '&trade;')
      },
      formattedFooterTextArtist: function () {
        if (!this.product.user_description) {
          return
        }
        return this.product.user_description.replace(/&nbsp;/g, ' ')
      },
      formattedFooterText: function () {
        return this.footerText.replace(/&nbsp;/g, ' ')
      },
      formattedpopularSearch: function () {
        return this.popularSearch.replace(/&nbsp;/g, ' ')
      },
      formattedshopNow: function () {
        return this.shopNow.replace(/&nbsp;/g, ' ')
      },
      populerSearchNew: function () {
        let listPopSearch = []
        let scope = this
        $.each(this.populerSearchData, function (key1, value1) {
          if (value1.categories && value1.categories.length) {
            $.each(value1.categories, function (key2, value2) {
              if (value2.sub_categories && value2.sub_categories.length) {
                $.each(value2.sub_categories, function (key3, value3) {
                  if (value3.url_key !== null && value1.name.toLowerCase().trim() === scope.currentCat && value3.url_key !== scope.currentSlug) {
                    listPopSearch.push({'name': value3.name, 'url': value3.url_key})
                  }
                })
              } else if (value2.url_key !== null && value1.name.toLowerCase().trim() === scope.currentCat && value2.url_key !== scope.currentSlug) {
                listPopSearch.push({'name': value2.name, 'url': value2.url_key})
              }
            })
          } else if (value1.url_key !== null && value1.name.toLowerCase().trim() === scope.currentCat && value1.url_key !== scope.currentSlug) {
            listPopSearch.push({'name': value1.name, 'url': value1.url_key})
          }
        })
        // console.log(listPopSearch)
        return listPopSearch
      },
      currentSlug () {
        return this.$route.path
      },
      currentCat () {
        if (this.$route.path.split('/')[1] === 'artists' || this.$route.path.split('/')[1] === 'tags') {
          return 'themes'
        } else if (this.$route.path.split('/')[1] === 'explore' || this.$route.path.split('/')[1] === 'product') {
          return 'accessories'
        }
        return this.$route.path.split('/')[1]
      },
      isSupimaLanding () {
        return this.$route && this.$route.path && this.$route.path.includes('supima-landing')
      },
      isActiveWearLanding () {
        return this.$route && this.$route.path && this.$route.path.includes('active-wear-landing')
      },
      isWinterWearLanding () {
        return this.$route && this.$route.path && this.$route.path.includes('winter-wear-landing')
      },
      footerCollapseStyle () {
        if ((this.isComboActive && !this.bannerPlaceHolderForGoForAppOnlySale && this.bannerPlaceHolderForMenWomenMsite && !this.$parent.isDesktop) && (this.$route.path === '/men' || this.$route.path === '/women' || this.$route.path === '/men' || this.$route.path === '/kids' || this.$route.path === '/categories' || this.$route.path === '/mywishlist' || this.$route.path === '/membership')) {
          return this.$route.path === '/membership' && !(this.exclusiveUser && this.exclusiveDetails && this.exclusiveDetails.expire_in >= 0) ? 'margin-bottom: 107px;' : 'margin-bottom: 62px;'
        } else {
          return this.footerCollapseControl && this.footerCollapseControl.bottomStyle
        }
      },
      setMenuTextExclusive () {
        if (this.isExclusive) {
          return 'Member'
        } else {
          return 'Be Member'
        }
      },
      storeListDetails () {
        if (this.storeDetails && this.storeDetails.length > 0) {
          return this.isExpanded ? [...new Map(this.storeDetails.map(item => [item['city'], item])).values()] : [...new Map(this.storeDetails.map(item => [item['city'], item])).values()].slice(0, 4)
        }
      },
      footerBrandText () {
        const brandText = this.globalBannerPlaceholder && this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.find(bannerData =>
        bannerData.is_active === true && bannerData.config_key === 'footer_homebrand_text')
        if (brandText) {
          return brandText.value
        } else {
          return false
        }
      }
    }
  }

</script>
<style lang="css" scoped>
  /* .tss-footer {
    min-height: 1359px;
  } */

  .stores-btn{
      border: none ;
      background: transparent ;
      color:blue ; 
      outline: none;
      padding: 0;
      font-weight: 600;
      font-family: 'Source Sans Pro', sans-serif;
      font-size: 15px;

    }

  .foot_menu{
    display: flex;
    justify-content: space-between;
  }
  .foot_menu li{
   padding: 0 5px;
  }
  .foot_menu li img{
    height: 42px;
  }
  ul,li{list-style: none; margin: 0; padding: 0;}
  .popsearch_section{padding: 6px 0;}
  .populer-extra {display: inline !important;margin-bottom: -3px;}
  .populer-extra p {display: inline !important;}
  .populer-extra a {
    padding-left: 3px !important;
    padding-right: 3px !important;
  }
  .popsearch01 .populer  {
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 12px;
    letter-spacing: normal;
    text-align: left;
    color: #525964;
    padding: 0 6px;
    position: relative;
    display: inline-block;
  }
  .popsearch01 .populer{
      padding-right: 3px;
      padding-left: 0;
      margin-right: 6px;
  }
  .cod li{display: inline-block; vertical-align: center; margin-right: 10px;}
  .cod li:last-child{margin-right: 0;}
  .cod ul{display: block; text-align: center;}
  .navi a{color: #58595b !important;font-size: 13px;font-family: Source Sans Pro,sans-serif;font-weight: 400;}
  .navi {display: block;}
  .navi div{display:inline-block;}
  .navi a{margin-right:15px; position: relative;}
  .navi a:after{
    content: '|';
    position: absolute;
    right: -10px;
    top: -2px;
  }

  .popsr_cont div, .popsr_cont a{
    display: inline-block; 
    vertical-align: middle;  
    font-size: 14px;
    letter-spacing: normal;
    text-align: left;
    color: #525964;
    font-family: 'Source Sans Pro', sans-serif;
    cursor: pointer;
  }
  .popsearch01 .populer::before{
    position: absolute; 
    content: '|';
    color: #525964;
    right: -3px;
    top: 50%;
    transform: translateY(-50%);
  } 
  .pop_0:first-child:after{display:none}
  .title012 h2{
    display: inline-block;
    margin: 21px 9.5px 17px 2px;
    font-family: Source Sans Pro,sans-serif;
    font-size: 15px;
    line-height: normal;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    font-weight: 600;
    color: #525964;
  }
  .popsearch01 .title012{
    font-family: OpenSans;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: #525964;
    position: relative;
    margin-bottom: 1px;
    overflow: hidden;
  }
  .popsearch01 .title012::after{
    content: '';
    border-bottom: solid 1px #a3a3a8;
    width: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .supima-footer {
    margin-top: -15px;
    background-color: #e7e6e9;
  }
  .additional-footer-container {
    font-size: 16px;
  }
  .additional-heading {
    padding: 10px 0;
    text-transform: uppercase;
    text-align: center;
    letter-spacing: 1.5px;
    background-color: #E71318;
    color: #fff;
    font-size: 2.4em;
    font-family: inherit;
    font-weight: 500;
    line-height: 1.1;
    margin-bottom: 10px;
  }
  .additional-footer-content {
    display: flex;
    justify-content: space-around;
    padding: 12px 0 18px;
  }
  .additional-item {
    display: flex;
    align-items: center;
    color: #000;
  }
  .footer-height{
    min-height:auto;
  }
  .footer-height-ul{
    min-height:140px;
  }
  .additional-amount {
    margin-right: 5px;
    margin-bottom: 0;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 700;
    font-size: 4.5em;
  }
  .additional-stats {
    margin-bottom: 0;
    font-size: 3em;
  }
  ul.footerCatmenu {
    text-transform: uppercase;
    margin-bottom: 0;
  }
  .app-store-logo {
    height: 40px;
    width: 126px;
  }
  .footerCatmenu li a {
    color: #ed2d2f;
    line-height: 30px;
    display: block;
    font-size: 13px;
  }
  .reportext {
    float: left;
    margin-top: 25px;
  }
  .footersocial {
    float: right;
  }
  .divider.d10 {
    margin: 10px 0;
  }
  .footer {
    margin-top: 30px;
  }
  .listheading {
    font-size: 14px;
    text-transform: uppercase;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 600;
  }
  .app-download-header {
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 600;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: .5rem;
    line-height: 1px;
  }

  .footerlinks ul.op_5,
  .footerlinks ul.op_5 .circleicon_light {
    color: #a7a9ac
  }

  .footerlinks ul.op_5 .circleicon_light {
    border-color: #a7a9ac;
  }
   .footer-navigation-link
    {
      color: #ed2d2f;
      line-height: 30px;
      display: block;
      font-size: 13px;
      text-transform: uppercase;
    }

  .divider.M0 {
    margin: 0;
  }
  .pt10 {
    padding-top: 10px;
  }
  .shippartners img {
    height: 30px;
    width: auto;
    padding: 0 5px;
  }
  .dinline {
    display: inline-block;
    padding: 0 5px;
  }
  .parentdinline {
    display: inline-block;
  }
  .payopt {
    width: 55px;
    height: auto;
  }
  .iconsdivider {
    width: 1px;
    border-left: 1px #ccc solid;
  }
  .footer-h1 {
    display: inline;
    font-size: 14px;
  }

  .footerIcon .col {
    display: flex;
    justify-content: center;
  }
  .payment-wrapper {
    flex: 1;
    background-image: url('assets/images/payments-icon.png');
    height: 78px;
    background-size: auto 100%;
    background-repeat: no-repeat;
  }
  .shipping-partners {
    gap: 10px;
  }

  .footer-exclusive-icon {
    height: 29px !important;
    width: auto;
  }

  .footer-exclusive-icon-text {
    text-align: center;
    font-weight: bold;
    font-size: 12px;
    line-height: 0.9;
  }
  .custom-font-size {
    font-size: 15px;
    font-weight: 600;
}

  @media screen and (max-width: 991px) {
    .additional-footer-container {
      font-size: 10px;
    }
    .additional-footer-content {
      padding: 10px 0 18px;
    }
    .additional-item {
      flex-direction: column;
    }
    .additional-amount {
      margin-right: 0;
    }
    footer {
      margin-top: 0px;
    }
    .mob_mtb0 {
      margin-top: 0;
      margin-bottom: 0px;
    }
    .footerlinks {
      padding-left: 20px;
    }
    
    .footersocial {
      float: inherit;
      text-align: center;
    }
    .payopt {
      width: 100%;
    }
    .mbrow {
      display: inherit;
    }
    .iconsdivider {
      display: none;
    }
    .mbcenter,
    .text-right.mbcenter {
      text-align: center !important;
    }
    .dinline {
      padding: 0 5px 0 0;
    }
    .parentdinline {
      display: flex;
      margin-bottom: 10px;
    }
    .parentdinline dinline {
      flex: 1;
    }
    .payment-tile > img {
      max-width: 55px;
      max-height: 42px;
    }
    .overlayBottomPadding {
      padding-bottom: 65px;
    }
  }
  @media screen and (max-width: 767px) {
    .ship-footer-icon {
        justify-content: flex-start !important;
        padding-left: 16px;
    }
    .popsearch01 .title012  {
    overflow: inherit;
    }
    .title012 h2{
      margin: 8px 9.5px 10px 2px;
    }
    .popsearch01 .title012:after{
      width: auto;
    }
  }
  @media screen and (max-width: 575px) {
    .additional-footer-container {
      font-size: 8px;
    }
    .additional-heading {
      padding: 5px 0;
      font-size: 1.8em;
    }
    .additional-amount {
      font-size: 3em;
    }
    .additional-stats {
      font-size: 2.5em;
    }
    .footerIcon .col{
      flex-direction: column;
    }
    .payment-wrapper {
      height: 68px;
    }
  }
</style>



// WEBPACK FOOTER //
// AppFooter.vue?27d61cba